var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { SystemIcon } from '@storeblocks/icon';
import { Contained, Outlined, Text, Icon } from './styled';
export const Button = forwardRef((_a, ref) => {
    var { disabled, variant = 'contained', loading = false, iconLeft = '', iconRight = '', onClick, children, size = 16, color, as = 'button', type = 'button' } = _a, props = __rest(_a, ["disabled", "variant", "loading", "iconLeft", "iconRight", "onClick", "children", "size", "color", "as", "type"]);
    const isIcon = variant === 'icon';
    function handleClick() {
        if (disabled || loading) {
            return (e) => e.preventDefault();
        }
        return onClick;
    }
    function renderLoading() {
        if (isIcon) {
            return null;
        }
        return (loading && (React.createElement(LoadingIndicator, { size: "small", color: variant === 'contained' ? 'on-primary' : 'primary' })));
    }
    function renderContent() {
        return (!loading && (React.createElement(React.Fragment, null,
            iconLeft && (React.createElement(SystemIcon, { className: "icon-left", name: iconLeft, size: isIcon ? size : 16, "aria-hidden": true })),
            // Wrapped children in span tag to prevent google translate error
            // See https://github.com/facebook/react/issues/11538#issuecomment-390386520
            !isIcon && React.createElement("span", null, children),
            iconRight && (React.createElement(SystemIcon, { className: "icon-right", name: iconRight, size: isIcon ? size : 16, "aria-hidden": true })))));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let Component = Contained;
    switch (variant) {
        case 'outlined':
            Component = Outlined;
            break;
        case 'text':
            Component = Text;
            break;
        case 'icon':
            Component = Icon;
            break;
        default:
            Component = Contained;
            break;
    }
    return (React.createElement(Component, Object.assign({}, props, { as: as, ref: ref, variant: variant, "aria-disabled": disabled, onClick: handleClick(), size: size, color: color, type: as === 'button' ? type : undefined, disabled: disabled }),
        renderLoading(),
        renderContent()));
});
export default Button;
